export default "__VITE_ASSET__26rzoj_m__"